import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import Select from "react-select";
import DateRange from "../../Component/DateRange/DateRange";
import { Table } from "../../Component/Table/Table";
import { admin_list } from "../redux/api/dummyJson";
import ScreenPagination from "../../Component/ScreenPagination/ScreenPagination";
import { Table2 } from "../../Component/Table/Table2";
import { Toast } from "../../Component/Toast";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import moment from "moment/moment";
import useStore from "../../LocalStore/useStore";
import CustomScroll from "../../Component/CustomScroll";
import SubmitButton from "../../Component/SubmitButton";

const Withdraw = () => {
  const { kv, set } = useStore();
  const withdraw = kv.withdraw || [];

  const navigate = useNavigate();
  const [displayDate, setDisplayDate] = useState(null);
  const [data, setData] = useState(withdraw);
  const [info, setInfo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState("");
  const [method, setMethod] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const isSubmitDisabled =
    !amount || isNaN(Number(amount)) || Number(amount) <= 0 || !method;
  // // console.log("isSubmitDisabled", isSubmitDisabled);

  const options = [
    { label: "Bank Transfer", value: "bank_tranfer" },
    { label: "UPI Transfer", value: "upi_tranfer" },
  ];

  const getList = async () => {
    let url_ = `list?page=${pageNumber}`;

    if (displayDate) {
      const formattedDate = moment(new Date(displayDate)).format("YYYY-MM-DD");
      url_ += `&date=${formattedDate}`;
    }

    // // console.log("url_", url_);

    try {
      const res = await get(`${URLS.WITHDRAW}/${url_}`);
      // // console.log("res withdraw get", res);

      if (res?.status === "success" && Array.isArray(res?.data)) {
        setData(res.data);
        set("withdraw", res.data);
        setTotalPages(res?.pagination?.total_pages || 1);
      } else {
        setData([]);
        setTotalPages(0);
      }
    } catch (err) {
      Toast("Failed to load history");
    }
  };

  useEffect(() => {
    getList();
  }, [displayDate, pageNumber]);

  const onSendReuest = async () => {
    if (amount && parseInt(amount, 10) < 100) {
      setInfo(true);
      return;
    }

    const payload = {
      type: method?.value,
      amount: amount,
    };

    // // console.log("payload", payload);

    try {
      setLoading(true);
      const res = await post(`${URLS.WITHDRAW}/apply`, payload);
      // // console.log("res send requst", res);

      if (res?.status === "success") {
        Toast(res.message || "Submitted successfully");
        setLoading(false);
        setAmount("");
        setMethod("");
        getList();
      }
    } catch (err) {
      // // console.log("err", err);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: 8,
      fontFamily: "f2",
      border: `1px solid ${state.isFocused ? "#8F0D3dCC" : "#8F0D3dCC"}`,
      backgroundColor: "transparent",
      boxShadow: state.isFocused ? "0 0 0 1px #8F0D3dCC" : "none",
      "&:hover": {
        borderColor: "#8F0D3dCC",
      },
      padding: "3px 10px",
      color: "#8F0D3dCC",
      height: 51,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.isFocused ? "#fff" : "#000",
      top: -1,
      position: "relative",
    }),
    placeholder: (provided, state) => ({
      ...provided,
      color: "#979797",
    }),
    // indicatorSeparator: () => ({
    //     display: "none",
    // }),
      dropdownIndicator: (provided) => ({
      ...provided,
      color: "#8F0D3d",
      "&:hover": {
        color: "#8F0D3d",
      },
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: 3,
      overflow: "hidden",
      zIndex: 999,
      backgroundColor: "#F0EDE6",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 999,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 999, // 👈 ensures dropdown always above footer
    }),
    option: (provided, state) => ({
  ...provided,
  backgroundColor: state.isSelected
    ? "transparent"
    : state.isFocused
      ? "transparent"
      : "transparent",
  color: state.isSelected ? "#00211fff" : "#8F0D3d",
  cursor: "pointer",
  ":active": {
    backgroundColor: "#8F0D3d33",
  },
}),
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Method",
        accessor: "method",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Amount",
        accessor: "amount",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">₹ {value}</p>;
        },
      },

      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-jc">
              <p
                className={`f1 ${value == "Pending" ? "err-btn" : "appr-btn"}`}
              >
                {value}
              </p>
            </div>
          );
        },
      },
    ],
    [],
  );

  return (
    <div
      style={{ marginBottom: 20, paddingBottom: 45 }}
      className="dashRightViews"
    >
      <CustomScroll>
        <div className="" style={{ padding: "0px 15px 4px 15px" }}>
          <div className="form-group text-start my-3">
            <div className="d-flex ac-jb  ">
              <p
                style={{ fontWeight: 600 }}
                className="mb-1 f3 fs-xs-16 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 primary"
              >
                Amount
              </p>
              <p className="mb-1 f3 fs-xs-13 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 err">
                *Min ₹ 100
              </p>
            </div>
            <div style={{ height: 51 }} className="d-flex ac-jb input-box">
              <input
                type="number"
                placeholder="Enter Amount"
                onChange={(e) => setAmount(e.target.value)}
                value={amount}
                onInput={(e) => {
                  if (e.target.value.length > 11) {
                    e.target.value = e.target.value.slice(0, 11);
                  }
                }}
                className=""
              />
              <p
                style={{ fontWeight: "600" }}
                className="f2 fs-xs-15 fs-sm-15 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 "
              >
                ₹
              </p>
            </div>
          </div>
          <div className="form-group text-start my-3">
            <div className="d-flex ac-js">
              <p
                style={{ fontWeight: 600 }}
                className="mb-1 f3 fs-xs-16 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 primary"
              >
                Method
              </p>
            </div>
            <Select
              className="location-search"
              options={options}
              value={method}
              onChange={setMethod}
              placeholder="Select Method"
              styles={customStyles}
              isSearchable={false}
              noOptionsMessage={() => ""}
              menuPortalTarget={document.body} // 👈 makes dropdown render at body level
            // isMulti
            />
          </div>
          {/* <button
            onClick={onSendReuest}
            disabled={isSubmitDisabled}
            className={`add-button f3 fs-xs-15 fs-sm-12 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17  ${isSubmitDisabled ? "disabled-btn" : ""
              }`}
            style={{
              cursor: isSubmitDisabled ? "not-allowed" : "pointer",
              opacity: isSubmitDisabled ? 0.6 : 1,
              marginBottom: 16,
              color: isSubmitDisabled ? "#00000099" : "#000000ff",
            }}
          >
            {loading ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
                style={{ color: "black", padding: 8 }}
              ></span>
            ) : (
              "Send Request"
            )}
          </button> */}
          <SubmitButton
            onClick={onSendReuest}
            title="Send Request"
            style={{ marginBottom: 16, }}
            disabled={isSubmitDisabled}
            isFormValid={isSubmitDisabled}
            loading={loading}
          />
          <h4 className="mb-3 f4 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 primary">
            Withdraw History
          </h4>
          <DateRange fromDate={displayDate} onChange={setDisplayDate} />
        </div>
        <div style={{ margin: 20, marginBottom: 80 }} className="mt-4">
          <Table2
            columns={columns}
            setPageno={setPageNumber}
            pagecount={totalPages}
            data={data}
            show={false}
          />
        </div>
      </CustomScroll>
      <ScreenPagination
        totalPages={totalPages}
        pagenumber={pageNumber}
        setPagenumber={setPageNumber}
      />
      {/* {popup && (
        <div className="img-popup-design1">
          <div className="img-popup1">
            {/* Close Button 
            <button className="close-btn" onClick={() => setPopup(false)}>
              ×
            </button>

            <textarea
              className="input-box3"
              name="reason"
              // onChange={handleChange}
              placeholder="Type your reason here..."
              rows="4"
            />

            <div className="d-flex ac-jc px-1 py-1">
              <button
                onClick={() => setPopup(false)}
                className="add-button w-100"
              >
                Block User
              </button>
            </div>
          </div>
        </div>
      )} */}
      {info && (
        <div className="modalOverlay2" onClick={() => setInfo(false)}>
          <div className="clasInfo2" onClick={(e) => e.stopPropagation()}>
            <p className="f3" style={{ alignSelf: "flex-start" }}>
              Withdraw amount should be more then ₹ 99
            </p>
            <button
              style={{ alignSelf: "flex-end" }}
              className="okBtn"
              onClick={() => setInfo(false)}
            >
              Okay
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
export default Withdraw;
